import { render, staticRenderFns } from "./PrimaryColorKidIcon.vue?vue&type=template&id=6785ad3c&"
import script from "./PrimaryColorKidIcon.vue?vue&type=script&lang=js&"
export * from "./PrimaryColorKidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports